import * as React from "react";
import { PieChart } from "@mui/x-charts/PieChart";
import { useDrawingArea } from "@mui/x-charts/hooks";
import { styled } from "@mui/material/styles";

const size = {
  width: 400,
  height: 150,
};

const StyledText = styled("text")(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: "middle",
  dominantBaseline: "central",
  fontSize: 13,
}));

function PieCenterLabel({ children }) {
  const { width, height, left, top } = useDrawingArea();
  return (
    <StyledText x={left + width / 2} y={top + height / 2}>
      {children}
    </StyledText>
  );
}

export default function AdminDonutChart({ claimData }) {
  const groupedData = claimData.reduce((result, item) => {
    const { branch, amount } = item;
    if (!result[branch]) {
      result[branch] = {
        branch,
        amount: 0,
      };
    }
    result[branch].amount += amount;

    return result;
  }, {});

  // Converting the grouped data object back to an array (if needed)
  const groupedArray = Object.values(groupedData);

  const total = claimData.reduce((acc, val) => acc + val.amount, 0).toFixed(2);
  const data = groupedArray.map((claim) => ({
    value: claim.amount,
    label: claim.branch,
  }));
  return (
    <PieChart
      colors={[
        "#dc2626",
        "#facc15",
        "#0e7490",
        "#065f46",
        "#22c55e",
        "#fb923c",
        "#a8a29e",
        "#64748b",
        "#fca5a5",
        "#fde68a",
      ]}
      series={[{ data, innerRadius: 50 }]}
      {...size}>
      <PieCenterLabel>{total}</PieCenterLabel>
    </PieChart>
  );
}
